import { DEFAULT_EMPTY_VALUE } from 'src/constants/companyReport';

interface Props {
  match: string;
  riskSuffix: boolean;
}

const RiskRating = ({ match, riskSuffix }: Props) => {
  const riskValue = match.toLowerCase();
  const allowedValues = ['none', 'low', 'medium', 'high', 'very high', 'sanctioned'];
  const riskSuffixValue = riskValue === 'sanctioned' ? 'CONNECTION' : 'RISK';

  return allowedValues.includes(riskValue) ? (
    <p
      className={
        'badge badge-risk py-1 px-3 badge-color-risk-' +
        riskValue.replace(/\s/g, DEFAULT_EMPTY_VALUE)
      }
    >
      {match.toUpperCase()} {riskSuffix ? riskSuffixValue : null}
    </p>
  ) : (
    <p className='badge badge-risk py-1 px-3 badge-color-risk-error-match'>Risk Rating Unavailable</p>
  );
}

RiskRating.defaultProps = {
  match: 'error',
  riskSuffix: false,
};

export default RiskRating;
